import { useState } from 'react';
import { useQuery } from '@tanstack/react-query';
import { listDocumentTypes } from '../../api/workflow';
import DocumentUploadModal from './DocumentUploadModal';

const STATE_STYLES = {
  missing: 'bg-gray-100 text-gray-600',
  uploaded: 'bg-amber-100 text-amber-800',
  verified: 'bg-green-100 text-green-800',
};

const STATE_LABELS = {
  missing: 'Missing',
  uploaded: 'Uploaded',
  verified: 'Verified',
};

export default function RequiredDocumentsPanel({ requiredDocuments, documents, candidateId, candidateStepId }) {
  const typesQuery = useQuery({ queryKey: ['document-types'], queryFn: listDocumentTypes });
  const [uploadType, setUploadType] = useState(null);

  if (!requiredDocuments || requiredDocuments.length === 0) return null;

  const nameFor = (code) => typesQuery.data?.find((t) => t.code === code)?.name || code;

  return (
    <div>
      <h4 className="mb-2 text-xs font-semibold uppercase tracking-wide text-gray-500">Documents</h4>
      <div className="grid grid-cols-1 gap-2 md:grid-cols-2">
        {requiredDocuments.map(({ code, required, verify }) => {
          const doc = documents.find((d) => d.document_type === code);
          const state = !doc ? 'missing' : doc.is_verified ? 'verified' : 'uploaded';

          return (
            <div key={code} className="flex items-center justify-between rounded-md border border-gray-100 px-3 py-2">
              <div>
                <span className="text-sm text-gray-700">{nameFor(code)}</span>
                {!required && <span className="ml-1.5 text-xs text-gray-400">(optional)</span>}
                {required && verify && <span className="ml-1.5 text-xs text-gray-400">(verification required)</span>}
              </div>
              <div className="flex items-center gap-2">
                <span className={`rounded-full px-2 py-0.5 text-xs font-medium ${STATE_STYLES[state]}`}>{STATE_LABELS[state]}</span>
                {!doc && (
                  <button onClick={() => setUploadType(code)} className="text-xs font-medium text-primary hover:underline">
                    Upload
                  </button>
                )}
              </div>
            </div>
          );
        })}
      </div>

      <DocumentUploadModal
        open={!!uploadType}
        onClose={() => setUploadType(null)}
        candidateId={candidateId}
        presetTypeCode={uploadType}
        presetStepId={candidateStepId}
      />
    </div>
  );
}
